
function submitContact() {
  var first = document.getElementById('cf-first').value.trim();
  var last  = document.getElementById('cf-last').value.trim();
  var email = document.getElementById('cf-email').value.trim();
  var msg   = document.getElementById('cf-msg').value.trim();
  var fmsg  = document.getElementById('form-msg');

  if (!first || !last) { fmsg.textContent = 'Please enter your name.'; fmsg.className = 'form-msg error'; return; }
  if (!email || !email.includes('@')) { fmsg.textContent = 'Please enter a valid email.'; fmsg.className = 'form-msg error'; return; }
  if (msg.length < 10) { fmsg.textContent = 'Please enter a message.'; fmsg.className = 'form-msg error'; return; }

  fmsg.textContent = 'Message submitted — we will get back to you as soon as possible.';
  fmsg.className = 'form-msg success';
  document.getElementById('cf-first').value = '';
  document.getElementById('cf-last').value = '';
  document.getElementById('cf-email').value = '';
  document.getElementById('cf-phone').value = '';
  document.getElementById('cf-msg').value = '';
}
